import { Component, inject, input, viewChild } from '@angular/core';

import { DropdownItemComponent } from '../../../../../common/dropdown/dropdown-item/dropdown-item.component';
import { CheckboxComponent } from '../../../../checkbox/checkbox.component';
import { Select2ListItemDirective } from '../../../default-templates/list-item/list-item.directive';
import { Select2Item } from '../../../types';

@Component({
  selector: 'rt-select-list-item-multi',
  imports: [Select2ListItemDirective, CheckboxComponent, DropdownItemComponent],
  template: `
    <ng-container
      *rtSelectListItem="
        selectType;
        let selectCtrl;
        let item = item;
        let isHoverState = isHoverState;
        let index = index
      "
    >
      <rt-dropdown-item (click)="selectCtrl.select$.next(item)" [class.hover]="isHoverState">
        <rt-checkbox
          prefix
          [checked]="
            reverseSelection()
              ? !selectCtrl.itemSelector.isSelected(item)
              : selectCtrl.itemSelector.isSelected(item)
          "
          [hasMargin]="false"
          (valueChange)="selectCtrl.select$.next(item)"
        />
        {{ item.label }}
      </rt-dropdown-item>
    </ng-container>
  `,
  styleUrls: ['../../../default-templates/list-item/list-item.component.less'],
  providers: [
    {
      provide: Select2ListItemDirective,
      useFactory: () => inject(MultiSelectListItemComponent).directive(),
    },
  ],
})
export class MultiSelectListItemComponent {
  public directive = viewChild.required(Select2ListItemDirective);

  public reverseSelection = input(false);

  public selectType: { items: Select2Item[] };
}
